import { useI18n } from "@/app/composables/useI18n"

export function isValidEmail(email) {
  const re = /\S[^\s@]*@\S+\.\S+/
  const { t } = useI18n()

  return re.test(email) || t("general.invalid_email")
}

export const rules = [isValidEmail]
